<template>
  <nav :class="'navigation ' + ui">
    <ul :class="'navigation__list ' + ui">
      <li
        :class="'navigation__wrapper ' + ui
        "
        v-for="item in itemsList"
        :key="item.id"
        @click="actionItem(item)"
      >
        <span :class="'navigation__item ' + ui">{{ item.value }}</span>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "Navigation",

  props: {
    itemsList: {
      type: Array,
    },
    ui: {
      type: String,
      default: "simple",
    },
    currentPath: {
      type: String,
    },
    hasAnchors: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      
      isOpen: false,
    };
  },

  methods: {
    actionItem(value) {
      this.$emit("actionItem", value);
    },
  },
};
</script>